module.exports = __webpack_public_path__ + "static/media/18_plantilla_cuadrada_combo_simple_cf_gaseosas_pet_1,75_sp.93b2b2e9.png";